// import { RePayment } from './../action/order.action';
import { Gift } from "./cart.interface";
import { PaginateModel } from "./core.interface";
// import { Coupon } from "./coupon.interface";
// import { OrderStatus } from "./order-status.interface";
// import { Stores } from "./store.interface";
import { Voucher } from "./voucher.interface";
// import { TransactionsData } from "./wallet.interface";

export interface OrderModel extends PaginateModel {
    orderHistory: Order[];
    total: number;
    totalCountNoFilters: number;
    userName: string;
    statusCount: UserOrderStatusCount[]
}

export interface UserOrderStatusCount {
    status: OrderStatus,
    count: number
}

export interface Order {
    id?: string;
    userName: string;
    items: OrderItem[];
    orderId: string;
    globalOrderId?: string;
    sumTotalPrice?: number;
    finalPrice: number;
    orderStatus: OrderStatus;
    orderDate?: string;
    receiverInfo: ReceiverInfo;
    appliedVoucher?: Voucher;
    appliedVouchers?: Voucher[];
    voucherDiscountAmount?: number;
    note?: string;
    paymentMethod?: string;
    isPassedToErp: boolean;
    expectedReceivePoints?: any[];
    giftExchange?: any[];
    shipments?: OrderShipment[];
    invoices: OrderInvoice[] | undefined;
    appliedCoin?: number;
    orderShipping?: OrderShipping[];
    paymentStatus: PaymentStatus | undefined;
    giftItems: Gift[];
    shipValue: number;
    childOrderIds: string[];
    childOrders: Order[] | undefined;
    displayStatus: {
        value: string;
        icon: string;
    };
}
export enum TempCoinSource {
  OrderPurchaseCalc = 0,
  RankingMileStones = 1,
  ProductCoin = 2,
  VoucherCoin = 3,
}

export interface OrderItem {
    imgUrl: string;
    name: string;
    price: number;
    productID: number;
    quantity: number;
    actualQuantity: string;
    totalPrice: number;
    sku: string;
    skU2: string;
    slug?: string;
    expiredDate?: string | null;
    expirationDate?: string | null;
}

export interface ReceiverInfo {
    address: string;
    phone: string;
    userName: string;
    email: string;
}

export interface OrderCheckout {
    total: CheckoutTotal;
}

export interface CheckoutTotal {
    convert_point_amount: number;
    convert_wallet_balance: number;
    coupon_total_discount: number;
    points: number;
    points_amount: number;
    shipping_total: number;
    sub_total: number;
    tax_total: number;
    total: number;
    wallet_balance: number;
}

export interface CheckoutPayload {
    consumer_id: number;
    products: OrderProduct[];
    shipping_address_id: number;
    billing_address_id: number;
    coupon?: string;
    points_amount?: boolean;
    wallet_balance?: boolean;
    delivery_description?: string;
    delivery_interval?: string;
    payment_method?: string;
}


export interface OrderProduct {
    product_id: number;
    variation_id: number | null | String;
    quantity: number;
}

export interface PlaceOrder {
    is_redirect: boolean;
    order_number: string;
    transaction_id: string;
    url: string;
}

export interface RePaymentPayload {
    order_number: number,
    payment_method: string
}

export enum OrderStatus {
    Created = 0,
    Progressing = 1,
    //Packing= 2,
    Shipping = 2,
    Done = 3,
    Cancelled = 40,
    Paid = 5,
    PartialPaid = 6,
    Slipted = 50,
}

export class ReOrderResponseModel {
    isSuccess: boolean;
    message: string;
    data: ProductAvailabilityResultModel[];
}

export class ProductAvailabilityResultModel {
    productId: number;
    avalibilityType: ProductAvalibilityType;
    message: string | null;
}

export enum ProductAvalibilityType {
    Ok = 10,
    OutOfStock = 20,
    StopSelling = 30
}

export interface PaymentMethod {
    value: string;
    label: string;
}

export interface OrderItem {
    paymentMethod: PaymentMethod;
}

export class OrderShipment {
    shipmentId: number;
    shipmentCode: string;
    shipmentDate: string | undefined;
    shipmentItems: ShipmentItem[] | undefined;
    boxCount: number;
}

export class ShipmentItem {
    productSku: string;
    combo_ProductSku: string | undefined;
    quantity: number;
    price: number | undefined;
    priceUnitAfterDiscount: number | undefined;
    lotNumber: string | undefined;
    expiryDate: string | undefined;
}
export class OrderInvoice {
    url: string;
    invoiceCode: string;
}

export class ReturnRequestCreate {
    userName: string;
    reason: string;
    orderId: string;
    items: ReturnRequestProductCreate[];
}

export class ReturnRequestProductCreate {
    isSelected: boolean = false;
    productInfo: OrderItem | undefined;
    quantityInShipment: number;
    shipmentDate: string | undefined;
    productSku: string;
    combo_ProductSku?: string | undefined;
    quantity: number;
    note: string | undefined;
    shipmentId: string | undefined;
    shipmentCode: string;
    lotNumber: string | undefined;
    expirationDate: string | undefined;
    price: number;
}

export enum ReturnRequestStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    InTransit = 4,
    Received = 5,
    Refunded = 6,
    Replaced = 7,
    Closed = 99
}

export const ReturnRequestStatusValue = {
    [ReturnRequestStatus.Pending]: "Vừa tạo",
    [ReturnRequestStatus.Approved]: "Đã chấp nhận",
    [ReturnRequestStatus.Rejected]: "Bị từ chối",
    [ReturnRequestStatus.InTransit]: "Đang vận chuyển",
    [ReturnRequestStatus.Received]: "Đã nhận hàng",
    [ReturnRequestStatus.Refunded]: "Đã hoàn tiền",
    [ReturnRequestStatus.Replaced]: "Đã đổi/trả",
    [ReturnRequestStatus.Closed]: "Đã đóng"
}

export class ReturnStatusHelper {
  static getLabel(status: ReturnRequestStatus): string {
    return ReturnRequestStatusValue[status] || 'Không xác định';
  }

  static getClass(status: ReturnRequestStatus): string {
    switch (status) {
      case ReturnRequestStatus.Approved: return 'bg-success';
      case ReturnRequestStatus.Rejected: return 'bg-danger';
      case ReturnRequestStatus.Pending: return 'bg-warning text-dark';
      case ReturnRequestStatus.InTransit: return 'bg-info text-dark';
      case ReturnRequestStatus.Received: return 'bg-primary';
      case ReturnRequestStatus.Refunded: return 'bg-success';
      case ReturnRequestStatus.Replaced: return 'bg-secondary';
      case ReturnRequestStatus.Closed: return 'bg-dark';
      default: return 'bg-light text-dark';
    }
  }
}


export class ReturnRequest {
    id: string;
    code: string;
    userName: string;
    reason: string;
    items: ReturnOrder[];
    status: ReturnRequestStatus;
    resolution?: ReturnResolution;
    history: ReturnStatusHistory[];
    createdAt: string;
    updatedAt: string;
}

export class ReturnOrder {
    orderId: string;
    items: ReturnItem[];
    refundCalculation: ReturnRefundCalculationResult;
    order: Order;
    returnType: ReturnRequestReturnTypeValue;
    returnTypeName: string;
}

export class ReturnItem {
    productSku: string;
    productName: string;
    quantity: number;
    buyQuantity: number;
    note: string;
    lotNumber?: string;
    price: number;
    shipmentId?: string;
    shipmentCode?: string;
    expiredDate?: string | null;
}
export class ReturnResolution {
    action: string;
    processedAt?: string;
    note?: string;
}
export class ReturnStatusHistory {
    status: string;
    note?: string;
    createdBy: string;
    createdAt: string;
}
export class ReturnPromotionImpact {
    voucherCode: string;
    voucherLost: boolean;
    adjustment: number;
}

export class ReturnRefundCalculationResult {
    baseRefund: number;
    promotionImpacts: ReturnPromotionImpact[];
    refundTotal: number;
}

export interface OrderShipping {
  transportCompany: string;
  trackingNumber: string;
  cost?: number;
  createdAt: string;
  estimatedPickTime?: string;
  estimatedDeliveryTime?: string;
  trackingUrl?: string;
  status: string
}

export enum ShippingStatus {
  NotShipped = 0,   // Chưa gửi hàng
  InTransit = 1,    // Đang vận chuyển
  Delivered = 2,    // Đã giao thành công
  Failed = 3        // Giao thất bại
}

export enum PaymentStatus {
  Unpaid = 0,    // Chưa thanh toán
  Paid = 1,      // Đã thanh toán
  PartialPaid = 2, // Thanh toán một phần
}

export interface OrderTransportHistory {
  eventDate: string;
  description: string;
  location?: string;
}

export enum ReturnRequestReturnTypeValue {
  NotDefined = 0,
  FullReturn = 10,
  ParialReturn = 20
}

export class MissingProduct {
    productName: string = '';
    sku: string = '';
    quantity: number = 0;
    price: number = 0;
    totalPrice: number = 0;
}
